import React, { useEffect, useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Share2, Check, Facebook, Instagram, MessageCircle, Link as LinkIcon, X } from 'lucide-react';
export const ReferralSection: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const steps = [{
    num: '1',
    title: 'Kup si 3 měsíční BHS systém + BHS průvodce výživou',
    desc: '(musíš ho mít aktivní a nevrácený)'
  }, {
    num: '2',
    title: 'Doporuč BHS systém a průvodce výživu kamarádovi',
    desc: '(Provize se uplatňují pouze pro 3 měsíční plán BHS + průvodce výživou)'
  }, {
    num: '3',
    title: 'Kamarád ho zakoupí',
    desc: 'a když ho nevrátí do 5 dní'
  }, {
    num: '4',
    title: '',
    desc: '',
    isFormStep: true
  }];
  const shareData = {
    title: 'BHS Systém',
    text: 'Doporučuji ti BHS systém a průvodce výživou! Nezapomeň do poznámky při nákupu napsat moje jméno.',
    url: window.location.origin + '/bhs'
  };
  const handleShareClick = async () => {
    if (isMobile && navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.error('Error sharing:', err);
      }
    } else {
      setShowShareMenu(!showShareMenu);
    }
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(`${shareData.text} ${shareData.url}`);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
      setShowShareMenu(false);
    }, 2000);
  };
  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareData.url)}&quote=${encodeURIComponent(shareData.text)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(shareData.text + ' ' + shareData.url)}`,
    messenger: `fb-messenger://share/?link=${encodeURIComponent(shareData.url)}`
  };
  return <section className="py-16 md:py-24 relative overflow-hidden" data-id="element-768">
      {/* Background Effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-green-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-769"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-770">
        <div className="max-w-4xl mx-auto" data-id="element-771">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-772">
            <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-sm font-bold tracking-wide uppercase mb-6 shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-773">
              Partnerský program
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white mb-8 tracking-tight" data-id="element-774">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-500 drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-775">
                Vydělávej
              </span>{' '}
              s BHS 💸
            </h2>

            <div className="bg-gradient-to-br from-gray-900/60 to-black/60 backdrop-blur-xl border border-white/10 rounded-2xl p-6 md:p-8 shadow-xl max-w-3xl mx-auto" data-id="element-776">
              <p className="text-xl md:text-2xl text-gray-300 font-medium leading-relaxed" data-id="element-777">
                Stačí doporučit BHS{' '}
                <span className="text-white font-bold" data-id="element-778">pár lidem</span> — a tvůj
                plán se ti může{' '}
                <span className="text-green-400 font-bold" data-id="element-779">vrátit zpět</span>.
                🎯
              </p>
            </div>
          </motion.div>

          {/* Explanation */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-gray-900/40 to-gray-900/20 backdrop-blur-xl border border-green-500/20 rounded-2xl p-6 md:p-8 mb-16 text-center shadow-[0_0_30px_rgba(34,197,94,0.05)] max-w-3xl mx-auto" data-id="element-780">
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-781">
              BHS není jen systém pro tvoji transformaci. 🚀
              <br data-id="element-782" />
              Je to i{' '}
              <span className="text-white font-bold" data-id="element-783">
                příležitost, jak si vydělat
              </span>
              . 💰
              <br data-id="element-784" />
              <br data-id="element-785" />
              <span className="text-gray-200" data-id="element-786">
                Doporuč ho lidem kolem sebe — a za{' '}
                <span className="text-green-400 font-bold" data-id="element-787">každého</span>, kdo
                si ho koupí, získáš{' '}
                <span className="text-white font-bold" data-id="element-788">odměnu</span>. 🎁
              </span>
            </p>
          </motion.div>

          {/* Steps */}
          <div className="mb-16" data-id="element-789">
            <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-10" data-id="element-790">
              Jak to funguje?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-791">
              {steps.map((step, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} viewport={{
              once: true
            }} whileHover={{
              y: -5,
              scale: 1.02
            }} className="relative bg-gradient-to-br from-gray-900/80 to-black/80 backdrop-blur-xl border border-white/10 rounded-2xl p-6 md:p-8 overflow-hidden group shadow-xl hover:shadow-[0_10px_40px_-10px_rgba(34,197,94,0.3)] hover:border-green-500/30 transition-all duration-500" data-id="element-792">
                  {/* Glow effect on hover */}
                  <div className="absolute inset-0 bg-gradient-to-br from-green-500/0 via-green-500/0 to-green-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-793"></div>

                  <div className="absolute -right-6 -top-6 text-8xl font-black text-white/5 group-hover:text-green-500/10 transition-colors duration-500 transform group-hover:scale-110 group-hover:rotate-12" data-id="element-794">
                    {step.num}
                  </div>

                  <div className="relative z-10" data-id="element-795">
                    <div className="w-14 h-14 bg-gradient-to-br from-gray-800 to-black border border-green-500/30 rounded-2xl flex items-center justify-center mb-6 shadow-[0_0_15px_rgba(34,197,94,0.2)] group-hover:shadow-[0_0_25px_rgba(34,197,94,0.4)] transition-shadow duration-500 transform group-hover:-translate-y-1" data-id="element-796">
                      <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400 font-black text-xl" data-id="element-797">
                        {step.num}
                      </span>
                    </div>
                    <h4 className="text-xl font-bold text-white mb-3 group-hover:text-green-400 transition-colors duration-300 leading-snug" data-id="element-798">
                      {(step as any).isFormStep ? <span className="block" data-id="element-799">
                          <span className="text-gray-200" data-id="element-800">
                            Ty vyplníš krátký formulář
                          </span>{' '}
                          <a href="https://docs.google.com/forms/d/e/1FAIpQLSdetCwYtiPw4Qx9O_b7F0MMgr2E6h7cW_41t763PiOP21yYXg/viewform" target="_blank" rel="noopener noreferrer" className="text-green-400 underline underline-offset-2 decoration-green-500/50 hover:decoration-green-400 transition-colors" onClick={e => e.stopPropagation()} data-id="element-801">
                            zde
                          </a>{' '}
                          <span className="text-gray-200" data-id="element-802">
                            a poté dostaneš provizi
                          </span>{' '}
                          <span className="inline-flex items-baseline gap-1 whitespace-nowrap" data-id="element-803">
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-300 via-emerald-400 to-green-300 font-black text-2xl md:text-3xl drop-shadow-[0_0_12px_rgba(34,197,94,0.5)] tracking-tight" style={{
                        textShadow: '0 0 20px rgba(34,197,94,0.3)'
                      }} data-id="element-804">
                              399 Kč
                            </span>
                            <span className="text-2xl" data-id="element-805">💸</span>
                          </span>
                        </span> : step.title}
                    </h4>
                    {step.desc && <p className="text-sm text-gray-400 leading-relaxed group-hover:text-gray-300 transition-colors duration-300" data-id="element-806">
                        {step.desc}
                      </p>}
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Emotional Block */}
          <div className="mb-16 text-center max-w-2xl mx-auto space-y-8" data-id="element-807">
            <motion.p initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true
          }} className="text-xl md:text-2xl text-gray-300 leading-relaxed" data-id="element-808">
              Stačí doporučit{' '}
              <span className="text-white font-bold" data-id="element-809">5–6 lidí</span>
              <br data-id="element-810" />a máš zpět{' '}
              <span className="text-green-400 font-bold" data-id="element-811">
                celou svoji investici
              </span>{' '}
              do plánu i výživy. 📈
            </motion.p>

            <div className="flex items-center justify-center gap-4" data-id="element-812">
              <div className="h-px w-16 bg-gradient-to-r from-transparent to-green-500/30" data-id="element-813"></div>
              <span className="text-green-500/40 text-lg" data-id="element-814">✦</span>
              <div className="h-px w-16 bg-gradient-to-l from-transparent to-green-500/30" data-id="element-815"></div>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} viewport={{
            once: true
          }} data-id="element-816">
              <p className="text-lg text-gray-400 mb-2 italic" data-id="element-817">A potom?</p>
              <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-818">
                Každý další prodej ={' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400 drop-shadow-[0_0_10px_rgba(34,197,94,0.3)]" data-id="element-819">
                  čistý zisk
                </span>{' '}
                pro tebe. 💎
              </p>
            </motion.div>
          </div>

          {/* CTA Button & Share Menu */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="text-center relative" data-id="element-820">
            <button onClick={handleShareClick} className="w-full md:w-auto px-10 py-5 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-400 hover:to-emerald-400 text-black font-black text-xl rounded-xl transition-all duration-300 shadow-[0_0_25px_rgba(34,197,94,0.4)] hover:shadow-[0_0_40px_rgba(34,197,94,0.6)] active:scale-[0.98] flex items-center justify-center mx-auto group" data-id="element-821">
              <Share2 className="mr-3 w-6 h-6 group-hover:-translate-y-1 transition-transform" data-id="element-822" />
              SDÍLET KAMARÁDŮM
            </button>

            {/* Desktop Share Menu Popup */}
            <AnimatePresence data-id="element-823">
              {showShareMenu && !isMobile && <motion.div initial={{
              opacity: 0,
              y: 10,
              scale: 0.95
            }} animate={{
              opacity: 1,
              y: 0,
              scale: 1
            }} exit={{
              opacity: 0,
              y: 10,
              scale: 0.95
            }} transition={{
              duration: 0.2
            }} className="absolute left-1/2 -translate-x-1/2 bottom-full mb-4 w-72 bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl overflow-hidden z-50" data-id="element-824">
                  <div className="p-4 border-b border-gray-800 flex justify-between items-center bg-gray-800/50" data-id="element-825">
                    <span className="font-bold text-white" data-id="element-826">Sdílet přes</span>
                    <button onClick={() => setShowShareMenu(false)} className="text-gray-400 hover:text-white transition-colors" data-id="element-827">
                      <X className="w-5 h-5" data-id="element-828" />
                    </button>
                  </div>
                  <div className="p-2 flex flex-col gap-1" data-id="element-829">
                    <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-3 hover:bg-gray-800 rounded-xl transition-colors text-gray-300 hover:text-white" data-id="element-830">
                      <Facebook className="w-5 h-5 text-blue-500" data-id="element-831" />
                      <span className="font-medium" data-id="element-832">Facebook</span>
                    </a>
                    <a href={shareLinks.messenger} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-3 hover:bg-gray-800 rounded-xl transition-colors text-gray-300 hover:text-white" data-id="element-833">
                      <MessageCircle className="w-5 h-5 text-blue-400" data-id="element-834" />
                      <span className="font-medium" data-id="element-835">Messenger</span>
                    </a>
                    <a href={shareLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-3 hover:bg-gray-800 rounded-xl transition-colors text-gray-300 hover:text-white" data-id="element-836">
                      <MessageCircle className="w-5 h-5 text-green-500" data-id="element-837" />
                      <span className="font-medium" data-id="element-838">WhatsApp</span>
                    </a>
                    <button onClick={copyToClipboard} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-800 rounded-xl transition-colors text-gray-300 hover:text-white w-full text-left" data-id="element-839">
                      {copied ? <Check className="w-5 h-5 text-green-500" data-id="element-840" /> : <LinkIcon className="w-5 h-5 text-gray-400" data-id="element-841" />}
                      <span className="font-medium" data-id="element-842">
                        {copied ? 'Zkopírováno!' : 'Kopírovat odkaz'}
                      </span>
                    </button>
                    <div className="px-4 py-3 mt-1 border-t border-gray-800" data-id="element-843">
                      <div className="flex items-center gap-3 text-gray-300 mb-1" data-id="element-844">
                        <Instagram className="w-5 h-5 text-pink-500" data-id="element-845" />
                        <span className="font-medium" data-id="element-846">Instagram</span>
                      </div>
                      <p className="text-xs text-gray-500 pl-8" data-id="element-847">
                        Zkopíruj odkaz a pošli ho do zpráv (DM) nebo přidej do
                        Stories.
                      </p>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </section>;
};